import React from "react";

import DataTable, { DataTablePropsType } from "commons/ui/datatable/DataTable";
import { GridItem } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

type PropsType<T> = DataTablePropsType<T> & {
    readonly tableTitle?: JSX.Element;
    readonly emptyTableLabel?: string;
    readonly emptyTableExtraButtons?: JSX.Element;
    readonly dontUsePaper?: boolean;
};

function DataTableSimple<T>({
    dataTableHook,
    extraButtons,
    className,
    tableTitle,
    extraRows,
    emptyTableLabel,
    emptyTableExtraButtons,
    dontUsePaper = false,
    dontShowExportXlsxButton = false,
    showExtraRowsWhenEmpty,
}: PropsType<T>) {
    return (
        <GridItem>
            {tableTitle}

            {(!dataTableHook.emptyTableMessageAvailable || emptyTableLabel === undefined) &&
                (dontUsePaper ? (
                    <DataTable
                        dataTableHook={dataTableHook}
                        extraButtons={extraButtons}
                        className={className}
                        extraRows={extraRows}
                        showExtraRowsWhenEmpty={showExtraRowsWhenEmpty}
                        dontShowExportXlsxButton={dontShowExportXlsxButton}
                    />
                ) : (
                    <Paper>
                        <DataTable
                            dataTableHook={dataTableHook}
                            extraButtons={extraButtons}
                            className={className}
                            extraRows={extraRows}
                            showExtraRowsWhenEmpty={showExtraRowsWhenEmpty}
                            dontShowExportXlsxButton={dontShowExportXlsxButton}
                        />
                    </Paper>
                ))}

            {dataTableHook.emptyTableMessageAvailable && emptyTableLabel && (
                <>
                    <GridItem
                        className={`table-empty-label ${
                            emptyTableExtraButtons ? "with-extra-buttons" : ""
                        }`}
                    >
                        <span>{emptyTableLabel}</span>
                    </GridItem>
                    {emptyTableExtraButtons && <GridItem>{emptyTableExtraButtons}</GridItem>}
                </>
            )}
        </GridItem>
    );
}

export default DataTableSimple;
